/**
 * testing redux actions
 * 
 * @author    Maurizio Tidei
 * @copyright © 2019 contexagon GmbH
 */


import {ACTIVATE_TEST_MODE, UPDATE_TEST_STATS} from "./consts";


export const updateTestStats = (restcalls) => ({
    type: UPDATE_TEST_STATS,
    restcalls: restcalls
});

export const activateTestMode = () => ({
    type: ACTIVATE_TEST_MODE
});